module.exports = __webpack_public_path__ + "img/solar-sun.31d5a794.png";